export default {
	articles: "Articoli",
	offerRequests: "Offerte",
	offerRequestsHintTitle: "Novità: offerte per grandi quantità e serie",
	offerRequestsHintText:
		"Ora potete richiedere qui offerte per grandi quantità, pezzi di serie o produzione robotizzata automatizzata.",
	orders: "Archivio ordini",
	cart: "Carrello",
	account: "Account",
	settings: "Impostazioni",
	manageUsers: "Gestire utenti",
	logout: "Disconnetti",
	hide: "Nascondi",
	privateAccount: "Account privato (numero cliente: {customerId})",
	companyAccount: "{companyName} (numero cliente: {customerId})",
	footer: {
		materials: "Materiali",
		materialsTooltip: "Elenco dei materiali disponibili",
		privacy: "Privacy",
		privacyTooltip: "Informativa sulla privacy",
		terms: "Condizioni generali",
		termsTooltip: "Condizioni generali di vendita di Blexon",
		imprint: "Impressum",
		imprintTooltip: "Impressum",
		languageTooltip: "Modifichi la lingua nelle impostazioni dell'account",
	},
};
